<div class="toaster-container" *ngIf="toasterService.isVisible$ | async">
  <div class="toaster-content" [ngClass]="toasterService.typeToast">
    <div>
      <img
        [src]="getIconPath(toasterService.typeToast)"
        [alt]="getIconAlt(toasterService.typeToast)"
      />
    </div>
    <div>
      <p class="pb-2">
        <b>{{ toasterService.titleToast }}</b>
      </p>
      <span class="text-toast">{{ toasterService.textToast }}</span>
    </div>
    <i class="bi bi-x-lg" (click)="toasterService.hideToaster()"></i>
  </div>
</div>
